import React, { useContext } from "react"
import defaultMill from "../data/manual/mill-cards.json"

const MillEffectsCtx = React.createContext(null)

export const MillEffectsProvider = ({ children }) => {
  const [map, setMap] = React.useState(defaultMill)
  return (
    <MillEffectsCtx.Provider
      value={{
        map,
        setMap,
      }}
    >
      {children}
    </MillEffectsCtx.Provider>
  )
}

export const useMillEffectsCtx = () => {
  const data = useContext(MillEffectsCtx)
  if (!data) throw new Error("called context hook outside provider")
  return data
}
